import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi';
import { risapi } from './risapi';
import { convertJsonToFormData } from '../commonfunctions';

export const getPartygroups = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/partygroups', filterParameters), getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const fetchPartygroup = async (tagId, callback) => {
    try {
        const response = await risapi.get(`/api/partygroups/${tagId}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const createPartygroup = async (newPartygroup, callback) => {
    try {
        const formData = convertJsonToFormData(newPartygroup);
        const response = await risapi.post('/api/partygroups', formData, getAxiosConfig());
        if (response.status === 201) {
            callback(response.data);
        }
    } catch (error) {
        callback(error.response.data);
    }
};

export const updatePartygroup = async (editPartygroup, callback) => {
    try {
        const formData = convertJsonToFormData(editPartygroup);
        formData.append('_method', 'put');
        
        const response = await risapi.post(`/api/partygroups/${editPartygroup.id}`, formData, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback(error.response.data);
    }
};

export const destroyPartygroup = async (deletePartygroup, callback) => {
    try {
        const response = await risapi.delete(`/api/partygroups/${deletePartygroup.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ partygroup: deletePartygroup });
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }

};


export const destroyPartygroupsMultiple =  async (ids,callback) => {
  
    try {
     
        var sendData = {};
        sendData.ids = ids;
        sendData._method = 'delete';
        const response = await risapi.post('/api/partygroups/delete/multiple',sendData,getAxiosConfig());

        console.log("delete multiple response",response);
        
        if (response.status === 204) {
            callback({partygroup:ids});
        }
    } catch (error) {
        callback(error);
    }
}
